import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  level?: "h2" | "h3";
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  level = "h2",
}: SectionHeaderProps) {
  const Heading = level;
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div>
        <Heading className="text-xl md:text-2xl font-heading font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          {title}
        </Heading>
        {subtitle && (
          <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}